import {createContext} from "react";

const GroupedProjectsTableContext = createContext({
    setShowGroupedProjects: null,
    setHideGroupedProjects: null
});

export default GroupedProjectsTableContext;